import AbstractService from 'core/abstracts/AbstractService';
import Facade from 'core/Facade';

class LoggedUserService extends AbstractService {
    getRights() {
        return this.request({
            method: 'GET',
            url:  Facade.getApiRoot() + 'bo/rights',
        }).then(responseData => {
            if (responseData.ok) {
                return responseData.json();
            }
            throw responseData;
        });
    }
}

export default new LoggedUserService();
